<template>
  <div>
    <div
      class="filter-row"
      :data-testid="testId"
      @click.stop="$emit('edit')"
    >
      <div>
        <p class="filterName">
          {{ label }}
        </p>
        <slot name="summary">
          <p class="filterValue">
            {{ summary }}
          </p>
        </slot>
      </div>
      <v-btn
        v-if="!active"
        :data-testid="`${testId}-clear`"
        variant="text"
        size="x-small"
        icon="mdi-delete-outline"
        @click.stop="$emit('clear')"
      />
    </div>
    <FilterSpec
      v-if="active"
      :filter="filter"
      :collection="collection"
      :components="components"
      @close-filter-specification="$emit('close')"
      @update-filters="(spec) => $emit('update', spec)"
    />
  </div>
</template>

<script lang="ts">
import FilterSpec from './FilterSpec.vue';

export default {
  name: 'FilterRow',
  components: {
    FilterSpec,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    /** What the row shows for its current value. Ignored when the `summary` slot is filled. */
    summary: {
      type: String,
      default: '---',
    },
    /** The filter as the `FilterSpec*` components read it. Only needed while the flyout is open. */
    filter: {
      type: Object,
      default: () => ({}),
    },
    /** Which component renders each filter type. */
    components: {
      type: Object,
      required: true,
    },
    /** Collection filters only. Layer filters have no collection. */
    collection: {
      type: String,
      default: '',
    },
    /** Whether this row's flyout is the open one. */
    active: {
      type: Boolean,
      default: false,
    },
    testId: {
      type: String,
      default: '',
    },
  },
  emits: ['edit', 'close', 'update', 'clear'],
};
</script>

<style scoped lang="scss">
.filterName {
  color: main.$npGray;
  font-size: 14px;
  font-weight: bold;
}

.filterValue {
  color: main.$npGray;
  font-size: 14px;
  font-family: main.$fontPrimary;
  font-weight: normal;
  text-align: left;
}

:deep(.v-btn) {
  margin-right: -5px;
  height: 32px;
  width: 32px;
  .v-icon {
    font-size: 22px;
  }
}

// Deliberately not positioned. The flyout is absolute and reads its `top` off the viewport, so its
// containing block has to stay the panel root.
.filter-row {
  padding: 0.75rem;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgb(245, 243, 243);
}
</style>
